export default {
  selectedCustomCardId: '',

  customCardList: [],
};



// WEBPACK FOOTER //
// ./src/app/custom-cards/store/state.js